export const setDataAtrOnlyInTests = (callback: () => void) => {
	callback();
	// if (getProjectBuildName() === "develop") {
	// }
};

/**
 * flags used to turn on/off some functionality via setting key to true in local storage
 */
export enum DebugFlags {
	/**
	 * certain functions vill execute only when this flags is true, used in tests envs
	 */
	MainDebug = "debug",
	/**
	 * force loading onboarding templates
	 */
	OnboardingDebug = "onboardingTemplateDebug",
	/**
	 * force open setup account flow
	 */
	SetupAccontDebug = "setupAccountDebug",
	/**
	 * hides modals pop over banners
	 */
	ModalsDebug = "debugModals",
	/**
	 * disables loading init template for tests
	 */
	DisableInitTemplate = "disableInitTemplate",
	/**
	 * shows minor update modal
	 */
	MinorUpdateModal = "minorUpdateModal",
	/**
	 * shows major update modal
	 */
	MajorUpdateModal = "majorUpdateModal",
	/**
	 * shows promocode modal
	 */
	PromocodeModal = "promocodeModal",
	/**
	 * shows graph focus state
	 */
	GraphFocusDebug = "graphFocusDebug",
	/**
	 * enables debug logging for node modifier operations
	 */
	NodeModifierDebug = "nodeModifierDebug",
	/**
	 * shows arch conf banner
	 */
	ArchConfBanner = "archConfBanner",
	/**
	 * shows maintenance modal
	 */
	MaintenanceModal = "maintenanceModal",
	/**
	 * shows hidden fullscales canvas and all additional information
	 */
	DebugMagicCanvas = "debugMagicCanvas"
}

/**
 * @description used to hide from users testing functionality
 * @returns
 */
export const isDebugFlag = (flag?: DebugFlags) =>
	localStorage.getItem(flag || DebugFlags.MainDebug) === "true";

export const executeFcOnlyOnFlag = (callback: () => void) => {
	if (isDebugFlag()) {
		callback();
	}
};
export const isModalsGlobalHidden = () => isDebugFlag(DebugFlags.ModalsDebug);
export const isInitTemplateGlobalHidden = () =>
	localStorage.getItem("disableInitTemplate") === "true";
